export const APP_NAME = "Solana";
export const SOLANA_PUBKEY_LEN = 32;
